"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = wait;
const asAbortable_1 = require("./asAbortable");
/**
 * Wait for a specific time
 * @param ms time to wait for in milliseconds
 * @param abortSignal to control abortion of any wait
 * @returns {Promise<void>} resolves when time has passed
 */
function wait(ms, abortSignal) {
    let timeoutRef;
    return (0, asAbortable_1.asAbortable)(new Promise((resolve) => {
        timeoutRef = setTimeout(resolve, ms);
    }), abortSignal).finally(() => {
        clearTimeout(timeoutRef);
    });
}
//# sourceMappingURL=wait.js.map